import { DefaultQueryParams } from '@frontend/api-utils';
import { ChartClient } from '@frontend/chart/api';
import { IotsUptimeByTypeListChart } from '@frontend/chart/components';
import { Chart, ChartBinSize, ChartQueryParam } from '@frontend/chart/types';
import { useEffect, useState } from 'react';

import { useInsightFetchRange } from '../../../analytics/insights/insight-detail/use-insight-fetch-range';
import { getLast30DaysChartRange } from '../../pudo/last-30-days-chart-range';
import { Last30DaysHardwareIotsUptimeByTypeListChartProps } from './last-30-days-hardware-iots-uptime-by-type-list-chart.component';

export const useLast30DaysHardwareIotsUptimeByTypeListChart = (props: Last30DaysHardwareIotsUptimeByTypeListChartProps) => {
    const [data, setData] = useState<Chart | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(true);

    const fetchRange = useInsightFetchRange(getLast30DaysChartRange);

    useEffect(() => {
        if (!props.accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        const { after, before } = fetchRange;

        ChartClient.fetchChartData(props.accountId, IotsUptimeByTypeListChart.definition, {
            [DefaultQueryParams.AFTER]: after,
            [DefaultQueryParams.BEFORE]: before,
            ...fetchRange.entityParams,
            [ChartQueryParam.BIN_SIZE]: ChartBinSize.FULL_PERIOD
        })
            .then((chart) => {
                if (!cancelled) {
                    setData(chart);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setData(undefined);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [props.accountId, fetchRange.key]);

    return { data, isLoading };
};
